module.exports = __webpack_public_path__ + "static/r11-2badd30dc8fe683780df9ab314df7260.jpg";